import * as Types from '../types';

// Shared-computer payload is a pass-through domain shape assembled by the modals;
// the action creators do not read any of its fields.
type SharedComputerObj = Record<string, unknown>;

interface ReqUserAdminAddSharedComputerAction {
  type: string;
  payload: {
    costCenterId: string;
    productAccessId: string;
    sharedComputerObj: SharedComputerObj;
    productName: string;
  };
}

export function reqUserAdminAddSharedComputer(
  costCenterId: string,
  productAccessId: string,
  sharedComputerObj: SharedComputerObj,
  productName: string,
): ReqUserAdminAddSharedComputerAction {
  const action = {
    type: Types.REQ_USER_ADMIN_ADD_SHARED_COMPUTER,
    payload: {
      costCenterId,
      productAccessId,
      sharedComputerObj,
      productName,
    },
  };
  return action;
}

interface SharedComputerResultAction {
  type: string;
  payload: {
    open: boolean;
    success: boolean;
    result: Record<string, unknown>;
    error: unknown;
    errorDetail: unknown;
  };
}

export function clientUserAdminAddSharedComputerResult(
  open: boolean,
  success: boolean,
  result: Record<string, unknown> = {},
  error: unknown = null,
  errorDetail: unknown = null,
): SharedComputerResultAction {
  return {
    type: Types.CLIENT_USER_ADMIN_ADD_SHARED_COMPUTER_RESULT,
    payload: {
      open,
      success,
      result,
      error,
      errorDetail,
    },
  };
}

export function clientUserAdminAddSharedComputerResultClear(): { type: string } {
  return {
    type: Types.CLIENT_USER_ADMIN_ADD_SHARED_COMPUTER_RESULT_CLEAR,
  };
}

interface ReqUserAdminModifySharedComputerAction {
  type: string;
  payload: {
    costCenterId: string;
    productAccessId: string;
    sharedComputerObj: SharedComputerObj;
    sharedComputerId: string;
    productName: string;
  };
}

export function reqUserAdminModifySharedComputer(
  costCenterId: string,
  productAccessId: string,
  sharedComputerObj: SharedComputerObj,
  sharedComputerId: string,
  productName: string,
): ReqUserAdminModifySharedComputerAction {
  const action = {
    type: Types.REQ_USER_ADMIN_MODIFY_SHARED_COMPUTER,
    payload: {
      costCenterId,
      productAccessId,
      sharedComputerObj,
      sharedComputerId,
      productName,
    },
  };
  return action;
}

export function clientUserAdminModifySharedComputerResult(
  open: boolean,
  success: boolean,
  result: Record<string, unknown> = {},
  error: unknown = null,
  errorDetail: unknown = null,
): SharedComputerResultAction {
  return {
    type: Types.CLIENT_USER_ADMIN_MODIFY_SHARED_COMPUTER_RESULT,
    payload: {
      open,
      success,
      result,
      error,
      errorDetail,
    },
  };
}

export function clientUserAdminModifySharedComputerResultClear(): { type: string } {
  return {
    type: Types.CLIENT_USER_ADMIN_MODIFY_SHARED_COMPUTER_RESULT_CLEAR,
  };
}
